import React from 'react';

import classes from './NoDataSadFace.module.css';

const NoDataSadFace = props => (
    <div className={classes.NoDataSadFace}>
        <img src="/assets/images/lonelyIconColor.svg" alt="No Data Sad Face" />
        <div>
            It's lonely here, configure a network to create devices and get data flowing.
        </div>
    </div>
);


export default NoDataSadFace;
